export const REDUX_HISTORY_UNDO_REDO = 'REDUX_HISTORY_UNDO_REDO'
